export const SEND_MAIL= "SEND_MAIL"
export const LIST_RATERS = "LIST_RATERS"

export const RATERS_SUCCESS = "RATERS_SUCCESS"
export const RATERS_ERROR = "RATERS_ERROR"
